<template>
  <div class="black-list-modal">
    <ModalComponentHeader>
      {{ blackList?.messages?.title }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <p v-if="blackList.UF_REASON" class="black-list-modal__text">{{ blackList.UF_REASON }}</p>

      <DefButtonPrimary @click="modal.hide()">OK</DefButtonPrimary>
    </ModalComponentBody>
  </div>
</template>

<script setup lang="ts">
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import useModal from '@use/useModal/useModal';
import type { IBlackListItem } from '@use/useBlackList';

defineProps<{ blackList: IBlackListItem }>();

const modal = useModal();
</script>

<style lang="scss" scoped>
.black-list-modal {
  display: flex;
  flex-direction: column;
  &__text {
    font-weight: 500;
    font-size: rem(14);
    line-height: 130%;
    margin-bottom: 16px;
  }
  :deep(.def-button-primary) {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
